import React from "react";
import { BaseButton, BaseModal } from "src/components";
import { RV_INCOMPLETE_REASON_MESSAGE, RvIncompleteReason } from "../../constants";

// 모달 렌더링 컴포넌트
const IssueModalRenderer = ({
  isOpen,
  title,
  message,
  type,
  onClick,
  onClose,
  payload,
}: {
  isOpen: boolean;
  title?: string;
  message?: string;
  type?: "delay" | "existing" | "fail" | "cancel";
  onClick: () => void;
  onClose: () => void;
  payload?: any;
}) => {
  if (!isOpen) return null;

  if (type === "cancel") {
    return (
      <BaseModal isOpen title={title} className="py30 px20" titleClassName="flex-center-center text-center my30">
        <div className="flex-center-center">
          <BaseButton className="base-btn minmax120 minmax-h40 mt30" title="확인" onClick={onClose} />
        </div>
      </BaseModal>
    );
  }

  if (type === "fail") {
    return (
      <BaseModal isOpen title={title}>
        <div>
          <p className="pre-formatted font15 text-primary1 text-left" style={{ lineHeight: "1.5" }}>
            {message}
          </p>
          {payload && (
            <div className="mt30">
              <p className="mb10 font15">실패 사유</p>
              <div style={{ backgroundColor: "#f2f4f6", lineHeight: "1.5" }} className="pa20">
                {payload.map((reason: RvIncompleteReason, idx: number) => (
                  <span key={idx} className="font15 font-weight-400">
                    {`${RV_INCOMPLETE_REASON_MESSAGE[reason]} ${idx !== payload.length - 1 ? " / " : ""}`}
                  </span>
                ))}
              </div>
            </div>
          )}
          <div className="flex-center-center mt30">
            <BaseButton className="base-btn minmax120 minmax-h40" title="확인" onClick={onClose} />
          </div>
        </div>
      </BaseModal>
    );
  }

  return (
    <BaseModal isOpen title={title} titleClassName="flex-center-center">
      <div>
        <p className="pre-formatted text-primary1 mt10" style={{ lineHeight: "1.5" }}>
          {message}
        </p>
        <div className="flex-center-center mt30">
          <BaseButton className="base-btn minmax120 minmax-h40 color-white mr10" title="신청 취소" onClick={onClose} />
          <BaseButton className="base-btn minmax120 minmax-h40" title="계속 진행" onClick={onClick} />
        </div>
      </div>
    </BaseModal>
  );
};

export default IssueModalRenderer;
